export default "__VITE_ASSET__BTCqQjj7__"